import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { LogoService } from '../../../settings/siteLogo/services/LogoService';

export const SignInLogo: React.FunctionComponent = () => {
  const logo = LogoService.getSignInLogo();
  const logoStyle: React.CSSProperties = {
    maxWidth: logo.width,
    maxHeight: logo.height,
  };

  return <img
    src={logo.image}
    title={logo.title}
    alt={Messages.signinLogo()}
    style={logoStyle}
    data-tb-test-id="tableau-server-logo"
  />;
};
